import React from "react";

const Language = ({ language, text, textSpecial }) => {
  if (text === "welcome") {
    if (language === "en") {
      return <span>Welcome</span>;
    }
    if (language === "tr") {
      return <span>Merhaba</span>;
    }
  }

  if (text === "cv") {
    if (language === "en") {
      return <span>CV</span>;
    }
    if (language === "tr") {
      return <span>CV</span>;
    }
  }

  if (text === "welcome message") {
    if (language === "en") {
      return (
        <span>
          Hi and welcome! I am <span className="fw-bold text-blue">Okan</span>.{" "}
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Merhaba, ismim <span className="fw-bold text-blue">Okan</span>.
        </span>
      );
    }
  }

  if (text === "who I am") {
    if (language === "en") {
      return (
        <span>
          I am{" "}
          <span className="fw-bold text-blue">
            Multidisciplinary Frontend Developer
          </span>{" "}
          with an <strong>engineering mindset</strong>, specializing in{" "}
          <strong>UI/UX design, software development, and performance</strong>{" "}
          optimization.
          <br />
          Experienced in{" "}
          <strong>
            frontend engineering, digital product design, and state management.
            <br />
          </strong>
          I create{" "}
          <strong>
            scalable, maintainable, and user-friendly applications.
          </strong>
          <br />
          Adept at{" "}
          <strong>
            problem-solving, team mentorship, and enforcing best coding
            practices.
          </strong>
          <br />I bridge the gap between design and development to{" "}
          <strong>deliver high-quality, business-driven solutions</strong>.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Ben <span className="fw-bold text-blue">Okan</span>.{" "}
          <b className="fw-bold text-blue">Dijital ürün tasarım</b> ve{" "}
          <b className="fw-bold text-blue">arayüz tasarım</b> geçmişine sahip{" "}
          <b className="fw-bold text-blue">önyüz geliştiricisiyim</b>.
        </span>
      );
    }
  }

  if (text === "what I do") {
    if (language === "en") {
      return (
        <span>
          Currently focused on <b className="fw-bold text-blue">Javascript</b>{" "}
          and <b className="fw-bold text-blue">React</b>
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          <b className="fw-bold text-blue">Javascript</b> ve{" "}
          <b className="fw-bold text-blue">React</b> ağırlıklı çalışıyorum.{" "}
        </span>
      );
    }
  }

  if (text === "what I did") {
    if (language === "en") {
      return (
        <span>
          Produced <b className="fw-bold text-blue">wireframes</b>,{" "}
          <b className="fw-bold text-blue">app designs</b>,{" "}
          <b className="fw-bold text-blue">user experience flows</b>,{" "}
          <b className="fw-bold text-blue">user interfaces</b> for web & mobile
          platforms, as a{" "}
          <b className="fw-bold text-blue">digital graphics designer</b> for
          almost <b className="fw-bold text-blue">10 years</b>.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Yaklaşık <b className="fw-bold text-blue">10 yıl</b> boyunca{" "}
          <b className="fw-bold text-blue">dijital ürün tasarımcısı</b> olarak
          web ve mobil platformlara{" "}
          <b className="fw-bold text-blue">wireframe'ler</b>,{" "}
          <b className="fw-bold text-blue">uygulama tasarımları</b>,{" "}
          <b className="fw-bold text-blue">kullanıcı deneyimi akışları</b> ve{" "}
          <b className="fw-bold text-blue">arayüz tasarımları</b> ürettim.
        </span>
      );
    }
  }

  if (text === "freelance") {
    if (language === "en") {
      return (
        <span>
          Worked as a freelancer for over{" "}
          <b className="fw-bold text-blue">5 years</b>. Worked on countless
          projects and{" "}
          <b className="fw-bold text-blue">self taught frontend development</b>{" "}
          in the meanwhile.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          <b className="fw-bold text-blue">5 yıl</b>dan uzun süre bağımsız
          çalışarak sayısız projede çalıştım. Aynı zaman zarfında da{" "}
          <b className="fw-bold text-blue">önyüz geliştiriciliği öğrendim</b>.
        </span>
      );
    }
  }

  if (text === "introduction") {
    if (language === "en") {
      return <span>Introduction</span>;
    }
    if (language === "tr") {
      return <span>Giriş</span>;
    }
  }

  if (text === "main purpose") {
    if (language === "en") {
      return (
        <span>
          The main purpose of this web page is to showcase my career and connect
          to other like minded people.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Bu projenin asıl amacı kariyerimi özetlemek ve benzer ilgi alanlarıyla
          ilgilenen kişilerle bağlantı kurabilmek.
        </span>
      );
    }
  }

  if (text === "project info") {
    if (language === "en") {
      return (
        <span>
          Designed the project and implemented with modifying{" "}
          <strong className="text-blue">Bootstrap</strong> without using any
          template.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Bu proje hiç bir hazır şablon kullanılmadan sadece{" "}
          <strong className="text-blue">Bootstrap</strong> kütüphanesi
          kullanılarak tasarlandı ve uygulandı.
        </span>
      );
    }
  }

  if (text === "worked on") {
    if (language === "en") {
      return (
        <span>
          Worked on <strong className="text-blue">VSCode</strong> with{" "}
          <strong className="text-blue">Javascript</strong> and{" "}
          <strong className="text-blue">React</strong>
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Proje <strong className="text-blue">VSCode</strong> kullanarak{" "}
          <strong className="text-blue">Javascript</strong> ve{" "}
          <strong className="text-blue">React</strong> ile hazırlandı.
        </span>
      );
    }
  }

  if (text === "version control") {
    if (language === "en") {
      return (
        <span>
          Used <strong className="text-blue">GitLab</strong> repository for
          version control.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Versiyon / sürüm kontrolleri için{" "}
          <strong className="text-blue">GitLab</strong> kullanıldı.
        </span>
      );
    }
  }

  if (text === "keep in mind") {
    if (language === "en") {
      return (
        <span>
          Better language support, complex css designs, dark / light mode,
          animations, seo rules / tags and project demos will be implemented in
          the future.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Daha iyi dil desteği, kompleks css tasarımlar, karanlık / aydınlık
          modu, animasyonlar, seo kuralları / etiketleri ve proje demoları gibi
          geliştirmeler eklenecek.
        </span>
      );
    }
  }

  if (text === "change language") {
    if (language === "en") {
      return (
        <span>
          Change <b className="text-blue">Language</b>
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          <b className="text-blue">Dil</b> değiştir
        </span>
      );
    }
  }

  if (text === "cv view download") {
    if (language === "en") {
      return (
        <span>
          You can <b>view</b> or <b>download</b> my{" "}
          <b className="text-blue">CV</b>.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          <b className="text-blue">CV</b>'mi <b>görebilir</b> ya da{" "}
          <b>indirebilirsiniz</b>.
        </span>
      );
    }
  }

  if (text === "view cv") {
    if (language === "en") {
      return (
        <span>
          View <span className="fw-normal"> CV</span>
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Önizleme <span className="fw-normal"> CV</span>
        </span>
      );
    }
  }

  if (text === "cv download") {
    if (language === "en") {
      return (
        <span>
          Download <span className="fw-normal">CV</span>
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          İndir <span className="fw-normal">CV</span>
        </span>
      );
    }
  }

  if (text === "contact") {
    if (language === "en") {
      return <span>Contact</span>;
    }
    if (language === "tr") {
      return <span>İletişim</span>;
    }
  }

  if (text === "contact preference") {
    if (language === "en") {
      return <span>Here are some platforms you can find me.</span>;
    }
    if (language === "tr") {
      return <span>Bu platformlarda beni bulabilirsiniz.</span>;
    }
  }

  if (text === "link information") {
    if (language === "en") {
      return (
        <span>Here's the information for {textSpecial} you can copy.</span>
      );
    }
    if (language === "tr") {
      return <span>{textSpecial} için kopyalabileceğiniz bilgi.</span>;
    }
  }

  if (text === "link clipboard") {
    if (language === "en") {
      return (
        <span>
          Copy To <b>Clipboard</b>
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          <b>Kopyala</b>
        </span>
      );
    }
  }

  if (text === "cancel") {
    if (language === "en") {
      return <span>Cancel</span>;
    }
    if (language === "tr") {
      return <span>İptal</span>;
    }
  }

  if (text === "link redirecting") {
    if (language === "en") {
      return (
        <span>
          {textSpecial[0]}
          You're being <b>redirected</b> to{" "}
          <span className="fw-bold">{textSpecial.direction}</span> in{" "}
          <b>{textSpecial.timer}</b> seconds.
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          <b>{textSpecial.timer}</b> saniye içinde yönlendirildiğiniz yer:{" "}
          <span className="fw-bold">{textSpecial.direction}</span>
        </span>
      );
    }
  }

  if (text === "go now") {
    if (language === "en") {
      return (
        <span>
          Go <b>Now</b>
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          Şimdi <b>Git</b>
        </span>
      );
    }
  }

  if (text === "open tab") {
    if (language === "en") {
      return (
        <span>
          Open In <b>New Tab</b>
        </span>
      );
    }
    if (language === "tr") {
      return (
        <span>
          <b>Yeni Sekme</b> Aç
        </span>
      );
    }
  }
};

export default Language;
